import { render, staticRenderFns } from "./MemberDocument.vue?vue&type=template&id=71af1f72&scoped=true&"
import script from "./MemberDocument.vue?vue&type=script&lang=js&"
export * from "./MemberDocument.vue?vue&type=script&lang=js&"
import style0 from "./MemberDocument.vue?vue&type=style&index=0&id=71af1f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af1f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71af1f72')) {
      api.createRecord('71af1f72', component.options)
    } else {
      api.reload('71af1f72', component.options)
    }
    module.hot.accept("./MemberDocument.vue?vue&type=template&id=71af1f72&scoped=true&", function () {
      api.rerender('71af1f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/components/MemberDocument.vue"
export default component.exports